import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Card, Icon, Popconfirm, Table } from 'antd'
import moment from 'moment'

import UploadFilePopup from '@components/Popup/UploadFilePopup'

import { files } from '@services/api'
import download from '@utils/download'
import { fileType } from '@texts/policy'
import { fileExt } from '@texts/files'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class Files extends Component<any> {
    state = { loadingFile: false }

    deleteFile = async id => {
        await files.delete({ id })
        this.props.fileUpdated()
    }

    downloadFile = async file => {
        this.setState({ loadingFile: true })
        const downloadedFile = await files
            .assert(file.url)
            .then(res => new Blob([res.data], { type: fileExt[file.file_ext] }))

        download(downloadedFile)
        this.setState({ loadingFile: false })
    }

    render() {
        const { list, loading, popupStore, policy_id, authStore, disable } = this.props
        const { loadingFile } = this.state
        const columns = [
            {
                title: 'הורד קובץ',
                key: 'download',
                align: 'right',
                width: 200,
                render: (_, record) => (
                    <Button disabled={loadingFile} onClick={() => this.downloadFile(record)}>
                        {!loadingFile ? <Icon type="vertical-align-bottom" /> : <Icon type="loading" />}
                        {loadingFile ? 'קובץ בהורדה...' : 'הורד קובץ'}
                    </Button>
                )
            },
            {
                title: 'שם הקובץ',
                key: 'name',
                align: 'right',
                render: (_, record) => <span>{record.file_name}</span>
            },
            {
                title: 'סוג הקובץ',
                align: 'right',
                key: 'type',
                render: (_, record) => <span>{fileType[record.type]}</span>
            },
            {
                title: 'תאריך העלאה',
                align: 'right',
                key: 'created_at',
                render: (_, record) => {
                    let date
                    if (record.created_at) {
                        date = moment(record.created_at).format('DD/MM/YYYY')
                    }
                    return <span>{date}</span>
                }
            },
            {
                title: 'הועלה על ידי',
                align: 'right',
                key: 'updated_by',
                render: (_, record) => {
                    return <span>{record.updated_by ? record.updated_by : 'מערכת'}</span>
                }
            },
            {
                align: 'left',
                key: 'delete',
                render: (_, record) => {
                    if (authStore.roles[0] === 'admin') {
                        return disable ? (
                            ''
                        ) : (
                            <Popconfirm
                                title="האם למחוק קובץ?"
                                onConfirm={() => this.deleteFile(record.id)}
                                okText="כן"
                                cancelText="לא"
                            >
                                <Button>
                                    <Icon type="delete" />
                                    מחיקה
                                </Button>
                            </Popconfirm>
                        )
                    }
                }
            }
        ]

        return (
            <Card
                style={{ marginTop: '1rem' }}
                headStyle={{ backgroundColor: '#dadce0' }}
                bodyStyle={{ padding: '0.7rem' }}
                loading={loading}
                title={<div>קבצים להורדה</div>}
            >
                {disable ? (
                    ''
                ) : (
                    <Button
                        type="primary"
                        onClick={() =>
                            popupStore.togglePopup('uploadFile', {
                                bucket: 'policies',
                                related: policy_id,
                                types: ['naot', 'policy']
                            })
                        }
                    >
                        <Icon type="upload" /> <strong style={{ fontSize: '1rem' }}>העלאת קובץ</strong>
                    </Button>
                )}

                <Table
                    className="center-table"
                    style={{ width: '100%', marginTop: '0.6rem' }}
                    rowKey="id"
                    columns={columns}
                    dataSource={list}
                    pagination={{
                        pageSize: 10
                    }}
                />
                <UploadFilePopup fileUploaded={() => this.props.fileUpdated()} />
            </Card>
        )
    }
}
